export const constants = {
    BASE_URL: process.env.REACT_APP_BASE_URL || 'http://localhost:3000',
    BASE_URL_USER: process.env.REACT_APP_BASE_URL_USER || 'http://localhost:3001',
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
    FACEBOOK: { CLIENT_ID: process.env.REACT_APP_FACEBOOK_CLIENT_ID, EMAIL_SCOPE: 'email' },
    GOOGLE: { CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID },
    STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
};
